import Vue from "vue";
import VueRouter from "vue-router";
import App from "./App.vue";
import "@/assets/scss/main.scss";
import VueMask from "v-mask";
import Vuelidate from "vuelidate";

import GlobalComponents from "./globalComponents";
import GlobalDirectives from "./globalDirectives";
import Notify from "@/components/NotificationPlugin";
import SideBar from "@/components/SidebarPlugin";

Vue.config.productionTip = false;

// router setup
import routes from "./router";

// configure router
const router = new VueRouter({
  mode: "history",
  routes,
  linkExactActiveClass: "active"
});

Vue.use(VueRouter);
Vue.use(GlobalComponents);
Vue.use(GlobalDirectives);
Vue.use(SideBar);
Vue.use(Notify);
Vue.use(VueMask);
Vue.use(Vuelidate);

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
